/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tense_Drab_Anaconda_MixInputs */

const en_tense_drab_anaconda_mix = /** @type {(inputs: Tense_Drab_Anaconda_MixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chart`)
};

const de_tense_drab_anaconda_mix = /** @type {(inputs: Tense_Drab_Anaconda_MixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diagramm`)
};

/**
* | output |
* | --- |
* | "Chart" |
*
* @param {Tense_Drab_Anaconda_MixInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tense_drab_anaconda_mix = /** @type {((inputs?: Tense_Drab_Anaconda_MixInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tense_Drab_Anaconda_MixInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tense_drab_anaconda_mix(inputs)
	return de_tense_drab_anaconda_mix(inputs)
});